export default {
  install(app) {
    app.config.globalProperties.$helper = this;
  },
  priceFormatter(price, toman = true) {
    try {
      let formattedPrice = price
        .toFixed(0)
        .replace(new RegExp("\\d(?=(\\d{3})+$)", "g"), "$&,");

      if (toman) {
        return formattedPrice + " تومان ";
      }

      return formattedPrice;
    } catch (e) {
      return 0 + " تومان";
    }
  },
  separate(Number) {
    Number += "";
    Number = Number.replace(",", "");
    let x = Number.split(".");
    let y = x[0];
    let z = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(y)) y = y.replace(rgx, "$1" + "," + "$2");
    return y + z;
  },
};
